import { render, staticRenderFns } from "./SafetyAccidentAnalysis.vue?vue&type=template&id=f5183970&scoped=true"
import script from "./SafetyAccidentAnalysis.vue?vue&type=script&lang=js"
export * from "./SafetyAccidentAnalysis.vue?vue&type=script&lang=js"
import style0 from "./SafetyAccidentAnalysis.vue?vue&type=style&index=0&id=f5183970&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5183970",
  null
  
)

export default component.exports